import styled from 'styled-components';

export const S_DateWrapper = styled.div`
  /* font-family: 'dongle';
  font-size: 1.2rem; */

  align-self: flex-start;
  text-align: center;
  padding: 20px;
`;

export const S_Total = styled.div`
  font-family: 'dongle';
  font-size: 1.5rem;

  text-align: center;
`;

export const S_CalorieTxt = styled.span`
  font-size: x-large;
  font-weight: bold;
  color: #2e6410;
`;
